var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 9.00012H5.33325C5.05992 9.00012 4.83325 8.77346 4.83325 8.50012C4.83325 8.22679 5.05992 8.00012 5.33325 8.00012H10.6666C10.9399 8.00012 11.1666 8.22679 11.1666 8.50012C11.1666 8.77346 10.9399 9.00012 10.6666 9.00012Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.6668C7.72667 11.6668 7.5 11.4401 7.5 11.1668V5.83347C7.5 5.56013 7.72667 5.33347 8 5.33347C8.27333 5.33347 8.5 5.56013 8.5 5.83347V11.1668C8.5 11.4401 8.27333 11.6668 8 11.6668Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 15.6668H5.99992C2.37992 15.6668 0.833252 14.1201 0.833252 10.5001V6.50013C0.833252 2.88013 2.37992 1.33347 5.99992 1.33347H9.99992C13.6199 1.33347 15.1666 2.88013 15.1666 6.50013V10.5001C15.1666 14.1201 13.6199 15.6668 9.99992 15.6668ZM5.99992 2.33347C2.92659 2.33347 1.83325 3.4268 1.83325 6.50013V10.5001C1.83325 13.5735 2.92659 14.6668 5.99992 14.6668H9.99992C13.0733 14.6668 14.1666 13.5735 14.1666 10.5001V6.50013C14.1666 3.4268 13.0733 2.33347 9.99992 2.33347H5.99992Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/add-square.997c730ac5066cfc1bf0835315871345.svg";
export { ForwardRef as ReactComponent };